<template>
  <div class="text-center">

 
    <v-dialog
      v-model="dialog"
      width="500"
    >


    <div class="my-2">
      <v-btn @click="dialogData = true">check data</v-btn>
    </div>

     <v-dialog
      v-model="dialogData"
    >
      <v-card>


        <v-card-title>OPCION
          <v-spacer></v-spacer>
          <v-btn outlined color="info" text @click="dialogData = false">CLOSE</v-btn>
        </v-card-title>
          <v-card-text class="pprint">{{opcion}}</v-card-text>

       
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined color="info" text @click="dialogData = false">CLOSE</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
 

      <template v-slot:activator="{ on, attrs }">
       
       <v-btn 
       v-bind="attrs"
          v-on="on"
          icon
          data-cy="add-opcion-input"
       @click="opcionEditIcon" 
       >
       
       <!-- <v-icon left>mdi-monitor-edit</v-icon></v-btn> -->

 <v-icon left>mdi-square-edit-outline</v-icon></v-btn>
       
       
      </template>

      <v-card>
      

        <v-card-text>
         
          <v-container>
    <v-row>

        <v-col cols="12">
          <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
 <v-row no-gutters>
    </v-row>
    
  
      <v-col cols="12">


        <v-text-field
            v-model="buscador" 
            placeholder="Ejemplo: Juan Perez"
            outlined
           
          >
          <template v-slot:label>
          <v-icon style="vertical-align: middle">
            mdi-magnify
          </v-icon>
          Busqueda por nombre de Imagenes Base
         
        </template>
          
          
          </v-text-field>



             
 <v-simple-table fixed-header>
    <template v-slot:default>


      <thead class="thead-dark">
   
        <tr>    
		<th scope="col">Descripcion</th>
		<th scope="col">Tipo</th>
		<!-- <th scope="col">LinkPhoto</th> -->
		<th scope="col">Icon</th>

		        <th scope="col">Seleccionar</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="imagenesBase in imagenesBasesBuscados" :key="imagenesBase.codigo">       
<!-- <td>{{imagenesBase.id}}</td> -->


<td v-on:click="seleccionarOpcionIcon(imagenesBase)">{{imagenesBase.descripcion}}</td>


<td v-on:click="seleccionarOpcionIcon(imagenesBase)">{{imagenesBase.tipo}}</td>


 <td v-on:click="seleccionarOpcionIcon(imagenesBase)">
   <v-avatar :size="50">
       <img
        :src="server_url+'api/imagenes_base/get_imagenes_base/'+ imagenesBase.linkPhoto"
        alt="Img"> 
    </v-avatar>
   </td> 

<td v-on:click="seleccionarOpcionIcon(imagenesBase)"><v-icon size="64">{{imagenesBase.icon}}</v-icon></td>

            <td @click="seleccionarOpcionIcon(imagenesBase)">
            
                
                  <v-icon left color="green darken-2"
                              >mdi-checkbox-marked-circle</v-icon
                            >
                         


            </td>
     
 </tr>
      </tbody>
    </template>
  </v-simple-table>
   


      </v-col>

    <v-col
        cols="12"
        md="12"
      >

      <v-text-field
           v-model="opcion.descripcion"
           label="Descripcion"
           :counter="2"
           :rules="textRules"
           disabled
         ></v-text-field>

          

   
 <v-text-field
           v-model="opcion.link"
           label="Link"
           disabled
         ></v-text-field>




       
      </v-col>

      <v-divider></v-divider>

        <v-card-actions>

            <v-btn
        :disabled="!valid"
        color="success"
        class="mr-4"
        @click="registrarOpcion"
      >
        Registrar
      </v-btn>

     

          <v-spacer></v-spacer>
           <v-btn
        color="error"
        class="mr-4"
        @click="dialog = false"
      >
        Cancelar
      </v-btn>
        </v-card-actions>

      
    </v-form> 

        </v-col>
    </v-row>
  </v-container>

        </v-card-text>

        
      </v-card>
    </v-dialog>
  </div>
</template>


<script>



import imagenesBaseService from "@/services/imagenesBaseService.js";

import opcionService from "@/services/opcionService.js";

import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';


import { http } from "@/services/config";


  export default {
    name:"OpcionIcon",

     props: {
    opcionData: {
      type: Object, 
      default: () => ({}) 
    },
    principalData: {
      type: Object, 
      default: () => ({}) 
    }

  },

    data: () => ({
 dialogData: false,
 buscador:'',
        imagenesBases: [],
        imagenesBase:{
id:'',
descripcion:'',
tipo:'',
linkPhoto:'',
icon:''
        },


       zoom: 50,
      archivo: null,
      fileData: {
        url: "",
        name:""
      },
       server_url: "",
       opcion:{

descripcion:'',
link:'',
linkPhoto:'',
tipo:'',
observacion:'',
id:'',
color:'#1F7087',
icon:'mdi-instagram',
principal:{}

          
        }
    ,
       valid: false,
    rules: {
                  required: value => !!value || 'Campo Requerido',
                  min: v => v.length >= 5 || 'Minimo 5 caracteres',
                  emailMatch: () => (`The email and password you entered don't match`),
                },
        	messages:undefined,
        
        
        
         textRules: [
              (v) => !!v || "Campo es requerido",
              (v) => (v && v.length >= 1) || "Debe contener al menos 3 caracteres",
            ],
        
            emailRules:  [
              (v) => !!v || "Correo es requerido",
              (v) => /.+@.+\..+/.test(v) || "Correo debe ser valido",
            ],
             numberRules: [
              (v) => (v >= 0) || "Valor debe ser mayor o igual a 0",
            ],
      dialog:false,
    }),
  created(){

       }
  ,mounted(){

  Fancybox.bind(this.$refs.container, '[data-fancybox]', {
      ...(this.options || {}),
    });

     this.server_url = http.defaults.baseURL;


     this.listarImagenesBases();
    
    },

    methods:{



    seleccionarOpcionIcon(imagenesBase) {
      console.log("Seleccionado paso 1 "+imagenesBase);

      this.opcion.imagenesBase=imagenesBase;
      this.opcion.imagen_base_id=imagenesBase.id;

      //Estira el link pre cargado de Imagenes Base
      this.opcion.linkPhoto=imagenesBase.linkPhoto;

      //Estira el Zoom pre cargado de Imagenes Base
      this.opcion.zoom=imagenesBase.zoom;

      this.$emit("opcionEditIcon", imagenesBase);
   //  this.dialog = false;
    },


      listarImagenesBases() {
      imagenesBaseService
        .listarImagenesBases()
        .then((resposta) => {
      //    console.log(resposta.data);
          this.imagenesBases = resposta.data;
        })
  
  },

     opcionEditIcon(imagenesBase){
       console.log("Ingrese al pulsar el boton de abrir icono nro (1) 2 ");
           this.opcion=this.opcionData;
      console.log(imagenesBase);

    },
    
    colorEdit(){
      console.log(this.color);
    },
    registrarOpcion(){

            if (this.$refs.form.validate()) {

              let res;
   // this.redirect='/opcion';

  console.log('El ide esta vacio '+this.opcion.id);

  
     //   this.opcion.color='#1F7087';
    if(this.opcion.id===""){

        console.log('El ide esta vacio '+this.opcion.id);

            opcionService.save(this.opcion).then(
        response =>{
            res= response.data.status,
            console.log('success');

            console.log(response.data);
       
        }).catch((errors) =>{

           console.log('error');
            console.log(errors);
        })
        console.log(res);
            
            this.$emit('opcionEditIcon',this.opcion);
            this.dialog=false;
            
    }else{

      console.log("Ingrese a actualizar");
    opcionService.update(this.opcion).then(
        response =>{
            res= response.data.status,
            console.log('success');

            console.log(response.data);
       
        }).catch((errors) =>{

           console.log('error');
            console.log(errors);
        })
        console.log(res);
            }
            this.$emit('opcionEditIcon',this.opcion);
            this.dialog=false;
        }
        
        }

        
        ,
    validate(){
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
    //  this.$refs.form.reset();
      this.limpiar();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    }
    ,
    limpiar(){

     
		this.opcion={
				nombre:'',
        apellido:'',
				linkPhoto:'',
				descripcion:'',
				observacion:'',
				id:'',
	}
    },

    },

    computed: {

      imagenesBasesBuscados() {
          return this.imagenesBases.filter(imagenesBase => {
            return imagenesBase.descripcion.toLowerCase().includes(this.buscador.toLowerCase());
          });
    
      }
    
      
      
    },
  watch: {
    
  }
  }
</script>